import { render, staticRenderFns } from "./OtherUserTemplateComplete.vue?vue&type=template&id=36914c16&lang=pug"
import script from "./OtherUserTemplateComplete.vue?vue&type=script&lang=ts"
export * from "./OtherUserTemplateComplete.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserTemplateComplete.vue?vue&type=style&index=0&id=36914c16&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports